import React, { JSX } from 'react';
import dayjs from 'dayjs';
import { DateDisplay } from '@ibe/components';
import { ApiDurationType, ApiSeason } from '@ibe/api';

export default abstract class DateUtil {
  public static formatDate(date: string | undefined, format?: string): JSX.Element {
    if (date) {
      return <DateDisplay utc date={date} format={format} />;
    }
    return <> </>;
  }

  public static getDuration(beginning: string, ending: string): string {
    return `${dayjs(ending).diff(dayjs(beginning), 'day')}`;
  }

  public static getDayNightDuration(
    beginning: string,
    ending: string,
    durationType?: ApiDurationType | null
  ) {
    if (durationType === null) {
      return -1;
    }
    if (durationType === ApiDurationType.NIGHT) {
      return dayjs(ending).diff(dayjs(beginning), 'day');
    }
    return dayjs(ending).add(1, 'day').diff(dayjs(beginning), 'day');
  }

  public static findClosestSeasonInPast(seasons: ApiSeason[], givenDate: string): ApiSeason | null {
    const current = dayjs(givenDate);

    const seasonsInPast = seasons.filter(
      season => season.endDate && dayjs(season.endDate).isBefore(current)
    );

    if (seasonsInPast.length <= 0) {
      return null;
    }

    let closestSeason = seasonsInPast[0];

    let currentDiff = Math.abs(current.diff(dayjs(closestSeason.endDate), 'day'));

    seasonsInPast.forEach(season => {
      const seasonDiff = Math.abs(current.diff(dayjs(season.endDate), 'day'));

      if (seasonDiff < currentDiff) {
        currentDiff = seasonDiff;
        closestSeason = season;
      }
    });

    return closestSeason;
  }

  public static findClosestSeasonInFuture(
    seasons: ApiSeason[],
    givenDate: string
  ): ApiSeason | null {
    const current = dayjs(givenDate);

    const seasonsInFuture = seasons.filter(
      season => season.startDate && dayjs(season.startDate).isAfter(current)
    );

    if (seasonsInFuture.length <= 0) {
      return null;
    }

    let closestSeason = seasonsInFuture[0];

    let currentDiff = Math.abs(current.diff(dayjs(closestSeason.endDate), 'day'));

    seasonsInFuture.forEach(season => {
      const seasonDiff = Math.abs(current.diff(dayjs(season.endDate), 'day'));

      if (seasonDiff < currentDiff) {
        currentDiff = seasonDiff;
        closestSeason = season;
      }
    });

    return closestSeason;
  }

  public static generateDatesInSpan(start: string, end: string, excludeEndDate?: boolean): Date[] {
    const dates: Date[] = [];
    let currentDate = dayjs(start, 'YYYY-MM-DD');
    const endDate = dayjs(end, 'YYYY-MM-DD');

    while (currentDate.isBefore(endDate) || currentDate.isSame(end)) {
      dates.push(currentDate.toDate());
      currentDate = currentDate.add(1, 'day');
    }
    if (excludeEndDate) {
      dates.pop();
    }
    return dates;
  }
}
